// extracted by mini-css-extract-plugin
export var heading = "sSVWf";
export var subheading = "ORJWy";